<template>
  <div>
    <h3>Arguments</h3>
    <v-container
      v-if="argumentsArray.length"
      fluid
      fill-height
    >
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
        >
          <v-text-field
            v-for="(value, key, index) in argumentsValues"
            :key="index"
            v-model="argumentsValues[key].value"
            :label="key"
            :disabled="argumentsSet"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            v-if="!argumentsSet"
            color="primary"
            dark
            small
            @click="setArguments()"
          >
            Set Arguments
          </v-btn>
          <v-btn
            v-else
            color="primary"
            dark
            small
            @click="changeArguments()"
          >
            Change Arguments
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      v-else
    >
      <v-alert
        border="top"
        color="indigo lighten-2"
        dark
      >
        These command does not need arguments!
      </v-alert>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'CronjobArguments',
  props: {
    argumentsArray: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      argumentsValues: {},
      argumentsError: false,
      argumentsSet: false,
    };
  },

  watch: {
    argumentsArray: {
      deep: true,
      handler() {
        this.initArgumentsValues();
      },
    },
  },

  methods: {
    initArgumentsValues() {
      this.argumentsValues = {};
      if (this.argumentsArray.length) {
        this.argumentsArray.forEach((arg, index) => {
          this.argumentsValues[arg.name] = {
            order: index + 1,
            value: '',
          };
        });
      } else {
        this.$emit('input', {});
      }
    },

    setArguments() {
      this.argumentsSet = true;

      this.$emit('input', this.argumentsValues);
    },
    changeArguments() {
      this.$emit('input', {});
      this.argumentsSet = false;
    },
  },
};
</script>

<style scoped>
.error-text {
  color: red;
}
</style>
